import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
import axios from 'axios';
export default {
  mixins: [popUp],
  props: {
    serverList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      codeList: [],
      formData: {
        id: '',
        length: '',
        quantity: '',
        level_id: '',
        expire_time: '',
        end_period_time: '',
        card_number: '',
        server_id: []
      },
      rules: {
        length: [{
          required: true,
          message: "请输入",
          trigger: "change"
        }],
        quantity: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        level_id: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        expire_time: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        end_period_time: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        server_id: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas, id, expire_time, end_period_time, level_code_id, card_number, server_id;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.copyPrimitive();

                  datas = JSON.parse(JSON.stringify(data));
                  id = datas.id, expire_time = datas.expire_time, end_period_time = datas.end_period_time, level_code_id = datas.level_code_id, card_number = datas.card_number, server_id = datas.server_id;
                  server_id = (server_id || '').split(',').map(Number);
                  console.log("server_id", server_id);
                  _this.formData = {
                    id: id,
                    level_id: level_code_id,
                    expire_time: expire_time,
                    end_period_time: end_period_time,
                    card_number: card_number,
                    server_id: server_id
                  };

                  _this.copyData();
                }

                _this.getCodeList();

                _this.dialogFormVisible = true;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getCodeList: function getCodeList() {
      var _this2 = this;

      this.$api.giftCodeLevelList().then(function (res) {
        if (res.code == 200) {
          _this2.codeList = res.data;
        }
      });
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var reqFn = _this3.formData.id ? 'editGiftCode' : 'generateGiftCodes';
                    var data = JSON.parse(JSON.stringify(_this3.formData));
                    data.server_id = data.server_id.join(",");

                    _this3.$api[reqFn](data).then(function (res) {
                      if (res.code == 200) {
                        _this3.$message.success(_this3.formData.id ? '修改成功' : '添加成功');

                        _this3.$emit('change');

                        _this3.dialogFormVisible = false;
                      } else {
                        _this3.$message.error(res.msg);
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};